module.exports = __webpack_public_path__ + "img/y1.e6845562.jpg";